import { render } from "./instance.vue?vue&type=template&id=78c61100&scoped=true"
import script from "./instance.js?vue&type=script&lang=js"
export * from "./instance.js?vue&type=script&lang=js"

import "./instance.vue?vue&type=style&index=0&id=78c61100&lang=less&scoped=true"

import exportComponent from "E:\\Workspace\\daifu\\daifu_channel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78c61100"]])

export default __exports__